import React from 'react';
import { Search } from 'lucide-react';
import { Input } from '@/components/ui/input';

// Listing filters for the Products admin: free-text search plus stock,
// visibility, source (manual vs Square) and platform selects.
export default function ProductsFilterBar({
  search, setSearch,
  stock, setStock,
  published, setPublished,
  manual, setManual,
  platform, setPlatform,
}) {
  const selectCls = 'appearance-none bg-[#111115] border border-white/10 text-white h-11 px-3 text-sm focus:border-primary/60 outline-none';
  return (
    <div className="flex flex-wrap items-center gap-3 mb-6">
      <div className="relative flex-1 min-w-[200px] max-w-sm">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search name, SKU, category…"
          className="bg-[#111115] border-white/10 text-white pl-9 h-11 placeholder:text-white/20 focus:border-primary/60"
        />
      </div>
      <select value={stock} onChange={(e) => setStock(e.target.value)} className={selectCls}>
        <option value="all">All stock</option>
        <option value="in">In stock</option>
        <option value="out">Out of stock</option>
      </select>
      <select value={published} onChange={(e) => setPublished(e.target.value)} className={selectCls}>
        <option value="all">All visibility</option>
        <option value="published">Published</option>
        <option value="hidden">Hidden</option>
      </select>
      <select value={manual} onChange={(e) => setManual(e.target.value)} className={selectCls}>
        <option value="all">All sources</option>
        <option value="manual">Manual</option>
        <option value="square">Square-managed</option>
      </select>
      <select value={platform} onChange={(e) => setPlatform(e.target.value)} className={selectCls}>
        <option value="all">All platforms</option>
        <option value="pc">PC</option>
        <option value="console">Console</option>
        <option value="both">Both</option>
      </select>
    </div>
  );
}